var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.Header = TotalJobsGroup.Header || {};

TotalJobsGroup.Header.GlobalSetup = (function () {

	function init() {
		try {
			// Ensure any lurking console.log() calls don't break IE.
			if (!window.console) {
				window.console = {};
				window.console.log = function () { };
			}

			//  A small dev advert
			console.log("Hello web developer, we're hiring! Find out at more at https://www.totaljobs.com/jobs-at/totaljobs-group/profile");
		}
		catch (e) {
		}
	}

	init();

})();